var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MatcLight"},[_c('h1',[_vm._v("ColorPicker Test")]),_c('div',{ref:"cntr",staticClass:"MatcToolbarRestSettings"})])}
var staticRenderFns = []

export { render, staticRenderFns }